<template>

  <div class="container">
    <table scroll="no">
      <thead>
      <tr>
        <th v-for="(column, index) of columns" :key="index">{{ column }}</th>
      </tr>
      </thead>
      <tbody>
      <slot class="content"/>
      </tbody>
    </table>
  </div>

</template>

<script>

export default {
  name: 'TableView',
  props: ['columns']
}

</script>

<style lang="scss" scoped>

@import '../../styles/main-colors.scss';

.container {
  overflow-x: auto;
  height: 100%;
  width: 100%;
}

table {
  table-layout: fixed;
  height: auto;
  min-width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
}

thead {
  min-width: 100%;
}

tbody {
  height: 100%;
  min-width: 100%;
}

tr {
  min-width: 100%;
}

th {
  padding: 15px;
  background-color: mix($background-grey, $background-light, 35%);
  text-align: left;
}

</style>



// WEBPACK FOOTER //
// src/components/common/TableView.vue